export { ro } from '@payloadcms/translations/languages/ro'
